import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ShoppingCartComponent } from 'src/app/components/shopping-cart/shopping-cart.component';
import { CartService } from 'src/app/core/services/cart.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { LITERALS } from 'src/app/core/constants/literals.constant';
import { SuccessMessageComponent } from '../../all-modals/success-message/success-message.component';
import { ErrorMessageComponent } from '../../all-modals/error-message/error-message.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { WalletService } from 'src/app/core/services/wallet.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { AddTokensComponent } from '../../wallet/add-tokens/add-tokens.component';
import { ProfileService } from 'src/app/core/services/profile.service';
import { REGEX_PATTERNS } from 'src/app/core/constants/regex-patterns.constant';
import { UploadSpaceModalComponent } from '../../wipod/upload-publication/upload-space-modal/upload-space-modal.component';

@Component({
  selector: 'app-gift-modal',
  templateUrl: './gift-modal.component.html',
  styleUrls: ['./gift-modal.component.scss']
})
export class GiftPublicationModalComponent implements OnInit, OnChanges {

  @Input() connectionData;
  @Input() purchasedData;
  @Input() content: any;
  @Input() regift: any;
  @Input() giftId;
  @Input() open;

  connection: any;
  remainingTokens = 0;
  userId: any;
  selectedUserImage = 'assets/images/modals/default-user-profile-image.png';

  connections: any = [];
  giftData: any;
  isUserTransferableError = false;
  dropdownConnection = {
    singleSelection: true,
    enableSearchFilter: true,
    enableFilterSelectAll: false,
    classes: "myclass custom-class form-control",
    text: 'Please select connection',
    labelKey: "name",
    noDataLabel: "No connections found",
    searchBy: ['name']
  };
  isError: boolean = false;
  errorMessage: string;
  submitted: boolean = false;
  isTokenError: boolean = false;
  tokenErrorMsg = LITERALS.AUTH.ERROR_MESSAGES.PLEASE_ADD_TOKEN_BEFORE_PURCHASE;
  giftForm: FormGroup;
  imagePath = environment.url;
  currentUser: any;
  textAreaLength = 0;
  contentType = 'Publication';
  isSuppError = '';
  isSupplementary: boolean = false;
  isSuppDisableParent: boolean = false;

  constructor(private activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private _cartService: CartService,
    private formBuilder: FormBuilder,
    private _walletService: WalletService,
    private authService: AuthService,
    private _profileService: ProfileService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit() {
    if (this.content && this.content.content_type) {
      if (this.content.content_type != 'document') {
        this.contentType = this.content.content_type;
      }
    }
    this.isSupplementary = this.authService.isSupplementaryAccount();
    this.currentUser = this.authService.getCurrentUser();
    this.loadTokens();
    this.loadConnections();
    this.giftForm = this.formBuilder.group({
      userData: ["", Validators.required],
      giftNote: ["", Validators.pattern(REGEX_PATTERNS.TEXT_AREA)]
    });
    if (this.open && sessionStorage.getItem('giftMaterialFormData')) {
      this.giftForm.setValue(JSON.parse(sessionStorage.getItem('giftMaterialFormData')));
      this.onSelectConnection(this.giftForm.controls.userData.value[0]);
    }
    sessionStorage.removeItem('giftMaterialFormData');
  }

  ngOnChanges() {
  }

  openShoppingCart() {
    this.activeModal.dismiss();
    this.modalService.open(ShoppingCartComponent, { windowClass: 'right' });
  }

  onEmail() {
    // const email = this.connectionData.find(val => {
    //   return val.user.id === +this.giftForm.userData;
    // });
    // this.giftForm.userEmail = email.user.email;
  }

  giftContent() {
    this.submitted = true;
    if (!this.giftForm.valid || this.isUserTransferableError) {
      return;
    }
    if (!this.regift) {
      if ((this.remainingTokens - this.content.tokens) < 0 && this.content.user_id != this.currentUser.user.id) {
        this.isTokenError = true;
        return;
      }
      const obj = {
        content_id: this.content.id,
        recipient_id: this.giftForm.get('userData').value[0].user.id,
        notes: this.giftForm.get('giftNote').value
      }
      this.spinner.show()
      this.isTokenError = false;
      this._cartService.giftContent(obj).subscribe((response: any) => {
        this.spinner.hide()
        if (response.success) {
          this.giftData = response.data.gift_record;
          this.closeDialog();
          const modalRef = this.modalService.open(SuccessMessageComponent, { centered: true });
          modalRef.componentInstance.message = "Gifted successfully";
          // this._toastr.success("Gifted successfully")
        }
        else if (!response.success && response.status === 'Validation failed') {
          const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
          modalRef.componentInstance.message = LITERALS.AUTH.ERROR_MESSAGES.YOU_CANNOT_GIFT_THE_SAME_CONTENT_AGAIN;
        } else if (!response.success && response.errors === "Validation failed: Recipient is not accepting any gifts currently") {
          this.isUserTransferableError = this.giftForm.get('userData').value[0].user.name;
        } else if (!response.success && response.errors === "Validation failed: Sender has already been taken") {
          const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
          modalRef.componentInstance.message = LITERALS.AUTH.ERROR_MESSAGES.GIFT_CONTENT_AGAIN_ERROR;
        }
        else {
          // this.errorMessage = response.message;
          if (response.errors == 'Insufficient tokens') {
            this.isTokenError = true;
          } else if (response.errors == "Duplicate content. Please select another material.") {
            this.isSuppError = response.errors;
          } else if (response.errors) {
            const modalRef = this.modalService.open(UploadSpaceModalComponent, { centered: true });
            modalRef.componentInstance.contentAccessError = response.errors;
            modalRef.componentInstance.isRedirectRequired = false;
          }
          this.isError = true;
          // this._toastr.warning('Something Went Wrong');
        }
      }, (error: any) => {
        // this._toastr.warning(error);
        this.errorMessage = error;
        this.isError = true;
      })
    } else {
      const obj = {
        recipient_id: this.giftForm.get('userData').value[0].user.id,
        notes: this.giftForm.get('giftNote').value
      }
      this.spinner.show();
      this._cartService.reGiftContent(this.giftId, obj).subscribe((response: any) => {
        this.spinner.hide();
        if (response.success) {
          this.giftData = response.data.gift_record
          this.activeModal.close(true);
          const modalRef = this.modalService.open(SuccessMessageComponent, { centered: true });
          modalRef.componentInstance.message = "Content re-gifted successfully";
        }
        else if (!response.success && response.status === 'Validation failed') {
          const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
          modalRef.componentInstance.message = LITERALS.AUTH.ERROR_MESSAGES.YOU_CANNOT_GIFT_THE_SAME_CONTENT_AGAIN;
        } else if (!response.success && response.errors === "Validation failed: Recipient is not accepting any gifts currently") {
          this.isUserTransferableError = this.giftForm.get('userData').value[0].user.name;
          // const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
          // modalRef.componentInstance.message = response.errors;
        } else if (!response.success && response.errors === "Validation failed: Sender has already been taken") {
          const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
          modalRef.componentInstance.message = LITERALS.AUTH.ERROR_MESSAGES.GIFT_CONTENT_AGAIN_ERROR;
        }
        else if (response.errors) {
          const modalRef = this.modalService.open(UploadSpaceModalComponent, { centered: true });
          modalRef.componentInstance.contentAccessError = response.errors;
          modalRef.componentInstance.isRedirectRequired = false;
        }
        else {
          const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
          modalRef.componentInstance.message = LITERALS.AUTH.ERROR_MESSAGES.RE_GIFT_CONTENT_ERROR;
        }
      }, (error: any) => {
        const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
        modalRef.componentInstance.message = LITERALS.AUTH.ERROR_MESSAGES.RE_GIFT_CONTENT_ERROR;
        this.errorMessage = error;
        this.isError = true;
      })
    }

  }

  closeDialog() {
    this.activeModal.close(this.giftData);
  }

  onSelectConnection(item) {
    this.isSuppError = '';
    this.isUserTransferableError = false;
    if (item && this.content.adult_content && item.user.user_account_type == 'supplementary') {
      this.isSuppError = LITERALS.AUTH.ERROR_MESSAGES.SUPP_ADULT_CONTENT_GIFT;
    }
    if (item.user.id == this.content.user_id) {
      this.isSuppError = LITERALS.AUTH.ERROR_MESSAGES.GIFT_CONTENT_TO_OWNER.replace('<user name>', item.name);
    }
    if (item && item.supplementary_user_disable_status && item.user.user_account_type == 'supplementary') {
      if (item.user.parent_user_id == this.currentUser.user.id) {
        this.isSuppError = 't';
        this.isSuppDisableParent = true;
      } else {
        this.isSuppError = LITERALS.AUTH.ERROR_MESSAGES.SUPP_DISABLED_MESSAGE;
      }
    }
    if (!item.transferable) {
      this.isUserTransferableError = item.name;
    }
    // this.shareForm.get('user').setValue([event]);
    if (item) {
      if (item.user.image) {
        this.selectedUserImage = this.imagePath + item.user.image;
      } else {
        this.selectedUserImage = 'assets/images/modals/default-user-profile-image.png';
      }
    }
    else {
      this.selectedUserImage = 'assets/images/modals/default-user-profile-image.png';
    }
  }
  OnConnectionDeselect(event) {
    this.isSuppError = '';
    // this.shareForm.get('user').setValue('');
    this.selectedUserImage = 'assets/images/modals/default-user-profile-image.png';
  }
  loadTokens() {
    // this.spinner.show();
    this._walletService.loadTokens().subscribe(
      (response: any) => {
        if (response.success) {
          this.remainingTokens = response.data.account.total_giftable_tokens;
          if (this.remainingTokens < 0 && this.content.user_id != this.currentUser.user.id) {
            // this.isTokenError = true;
          }
        }
        else if (response.status == 422) {
          this.remainingTokens = 0;
        }
      });
  }
  addMore() {
    // return;
    sessionStorage.setItem('giftMaterialFormData', JSON.stringify(this.giftForm.value));
    const modalRef = this.modalService.open(AddTokensComponent, { size: 'lg', centered: true, windowClass: 'add-token' });
    modalRef.componentInstance.sourceCart = 'giftCart';
    modalRef.componentInstance.inputTokens = (this.remainingTokens - this.content.tokens) < 0 ? Math.ceil(Math.abs(this.remainingTokens - this.content.tokens)) : null;
    // this._router.navigate(['/material-detail-page', this.contentId], { queryParams: { source: 'cart' } })

    // modalRef.result.then((result) => {
    //   this.ngOnInit();
    // }, (reason) => {
    // });
  }

  loadConnections() {
    this._profileService.fetchConnections().subscribe(
      (response: any) => {
        if (response.success && response.data.connections.length > 0) {
          this.connections = response.data.connections;
          if (this.connections.length > 0) {
            if (this.regift) {
              this.connections = this.connections.filter((element) => {
                return element.user.id != this.regift
              })
            }
            this.connections.forEach(element => {
              if (element.user.name) {
                element.name = element.user.name;
              }
            });
          }
        } else {
          this.dropdownConnection.noDataLabel = "No connections, yet";
          this.connections = [];
        }
      });
  }

  textAreaAdjust(event) {
    this.textAreaLength = event.target.value.length;
  }
}
